// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/outline_expand.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'outline_expandPixelShader';
const shader = `varying vec2 vUV;
uniform sampler2D textureSampler;
uniform vec2 kernel;
uniform vec2 direction;
uniform vec2 uvScale;
#define MAX_COLORS 10
void main(void) {
float weights[7];
weights[0] = 0.05;
weights[1] = 0.1;
weights[2] = 0.2;
weights[3] = 0.3;
weights[4] = 0.2;
weights[5] = 0.1;
weights[6] = 0.05;
vec2 delta = direction * kernel * uvScale;
vec2 start = uvScale * vUV - 3.0 * delta;
vec2 offset = vec2(0., 0.);
vec4 outCol = vec4(0);
float oldDist = 10000.;
for (int i = 0; i < 7; i++)
{
vec4 col = texture2D(textureSampler, start + offset);
float newDist = length(offset - delta * 3.0);
float isLess = float(col.r >= 1./float(MAX_COLORS + 1) && (newDist < oldDist || outCol.r == 0.));
oldDist = mix(oldDist, newDist, isLess);
outCol.r = mix(outCol.r, col.r, isLess);
outCol.b = mix(outCol.b, col.b, isLess);
outCol.a += weights[i] * col.a;
offset += delta;
}
outCol.g = texture2D(textureSampler, start + delta * 3.).g;
gl_FragColor = outCol;
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const outline_expandPixelShader = { name, shader };
//# sourceMappingURL=outline_expand.fragment.js.map